<template>
  <div>
    <b-row
      v-for="(condition, conditionIndex) in field.conditions"
      :key="`${field.fieldForm.field}-${conditionIndex}`"
      class="condition-row"
    >
      <b-col md="10">
        <b-form-group>
          <b-input-group>
            <div class="competition-checkbox-wrapper">
              <b-form-checkbox
                class="competition-checkbox pt-3"
                :checked="condition.value"
                @change="onValueChanged($event, 'value', conditionIndex)"
              >
                {{ field.fieldForm.allowedOperators[0].friendlyNameOfAction }}
              </b-form-checkbox>
            </div>
          </b-input-group>
        </b-form-group>
        <company-field-errors
          v-if="getError(conditionIndex).length > 0"
          :errors="getError(conditionIndex)"
          :innerKey="`condition-${conditionIndex}-error-`"
        />
      </b-col>
      <b-col md="2">
        <span class="delete-text" @click="onDeleteClicked(conditionIndex)">
          <delete-field :hasPadding="true" />
        </span>
      </b-col>
    </b-row>
    <b-row
      v-if="field.fieldForm.allowedOperators.length !== field.conditions.length"
      class="add-filter"
      @click="onAddFilterClicked"
      md="12"
    >
      <add-new-field />
    </b-row>
  </div>
</template>
<script>
import CompanyFieldErrors from './CompanyFieldErrors.vue'
import AddNewField from './AddNewField.vue'
import DeleteField from './DeleteField.vue'
export default {
  name: 'BooleanFilter',
  props: ['field', 'onChanged', 'getFieldFormErrors', 'onDelete'],
  components: { CompanyFieldErrors, AddNewField, DeleteField },
  methods: {
    onFieldChanged: function(updatedField) {
      this.onChanged(updatedField)
    },
    getError: function(conditionIndex) {
      return this.getFieldFormErrors({ key: this.field.fieldForm.field, index: conditionIndex })
    },
    onValueChanged: function(value, key, index) {
      const updatedField = { ...this.field }
      updatedField.conditions = [...updatedField.conditions]
      updatedField.conditions[index] = { ...updatedField.conditions[index] }
      updatedField.conditions[index][key] = [value]
      this.onFieldChanged(updatedField)
    },
    onAddFilterClicked: function() {
      const updatedField = { ...this.field }
      updatedField.conditions = [...updatedField.conditions]
      updatedField.conditions.push({
        operator: this.field.fieldForm.allowedOperators[0],
        value: false
      })
      this.onFieldChanged(updatedField)
    },
    onDeleteClicked: function(index) {
      const updatedField = { ...this.field }
      updatedField.conditions = [...updatedField.conditions]
      updatedField.conditions.splice(index, 1)
      this.onFieldChanged(updatedField)
    }
  }
}
</script>
<style>
competition-checkbox-wrapper {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  flex-direction: column;
  align-content: flex-start;
}
</style>
